import React from "react";
import { DialogContent, Box, Typography, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import permissionVideo from "../../../../assets/permissionVideo.mp4";
const Permission = ({ Text }) => {
    const { t } = useTranslation();

    const iconName = Text === "mic_permission_text" ? "mic_off" : "videocam_off";

    return (
    <>
        <DialogTitle>
            <div className="permission-type-text"
            style={{ display: "flex", alignItems: "flex-start" }}
            >
            <span
                    className="material-symbols-outlined"
                    style={{ fontSize: '1.5rem', color: '#d32f2f', marginBottom: '0.625rem' }}
                >
                    {iconName}
                </span>

                <Typography>{t(Text)}</Typography>
            </div>
        </DialogTitle>
        <DialogContent>
            <Box>
            <video
            src={permissionVideo}
            autoPlay 
            loop 
            muted 
            playsInline
            style={{ width: "100%", borderRadius: "1rem" }}
          />
            </Box>
        </DialogContent>
    </>
    );
};

export default Permission;